module.exports = __webpack_public_path__ + "img/20210906-1630910899210172.23a445cd.jpg";